export default {
  common: {
    filters: {
      startingDate: {
        label: 'Starting date',
        placeholder: 'YYYY-MM-DD hh:mm:ss'
      },
      endDate: {
        label: 'End date',
        placeholder: 'YYYY-MM-DD hh:mm:ss'
      },
      operators: {
        label: 'Operator(s)',
        placeholder: 'Select operator(s)'
      },
      statuses: {
        label: 'Status(es)',
        placeholder: 'Select status(es)'
      },
      operationIds: {
        label: 'Operation Id(s)',
        placeholder: 'Select operation id(s)'
      },
      recipient_msisdn: {
        label: 'Recipient phone number',
        placeholder: 'Select recipient phone number'
      },
      resultsNumber: {
        label: 'Number of results to display at page'
      }
    }
  }
};
